<template>
  <div class="content">
    <div class="bg">
      <div class="titleline">
        <span class="title">设备编号</span>
        <span class="time">汇报时间</span>
        <span class="point">坐标</span>
        <span class="locate">地点</span>
        <span class="device">关联设备</span>
        <span class="handle">操作</span>
      </div>
      <div class="wrapper">
        <div class="content" v-for="(l, i) in list" :key="i">
          <div class="item">
            <div class="title">
              <p class="words">
                {{l.name}}
              </p>
            </div>
            <div class="time">{{l.time}}</div>
            <div class="point">{{l.point}}</div>
            <div class="locate">{{l.locate}}</div>
            <div class="device">{{l.device}}</div>
            <div class="handle">
              <div class="btn">
                关联
              </div>
            </div>
          </div>
        </div>
      </div>
      <pages :allNum="pageCount" :cur="pageIndex"></pages>
    </div>
  </div>
</template>

<script>
import pages from '@components/pages'

export default {
  name: 'GPS',
  components: {
    pages
  },
  data() {
    return {
      pageCount: 10,
      pageIndex: 1,
      list: [
        {
          name: '12号车沪JZ0739',
          time: '2019-03-23 17:30',
          point: '121.44936,31.18295',
          locate: '近龙华路华容路中心东北 0.168公里, 在上海市内',
          device: '01号车沪ML7903'
        },
        {
          name: '12号车沪JZ0739',
          time: '2019-03-23 17:30',
          point: '121.44936,31.18295',
          locate: '近龙华路华容路中心东北 0.168公里, 在上海市内',
          device: '01号车沪ML7903'
        },
        {
          name: '12号车沪JZ0739',
          time: '2019-03-23 17:30',
          point: '121.44936,31.18295',
          locate: '近龙华路华容路中心东北 0.168公里, 在上海市内',
          device: '01号车沪ML7903'
        },
        {
          name: '12号车沪JZ0739',
          time: '2019-03-23 17:30',
          point: '121.44936,31.18295',
          locate: '近龙华路华容路中心东北 0.168公里, 在上海市内',
          device: '01号车沪ML7903'
        },
        {
          name: '12号车沪JZ0739',
          time: '2019-03-23 17:30',
          point: '121.44936,31.18295',
          locate: '近龙华路华容路中心东北 0.168公里, 在上海市内',
          device: '01号车沪ML7903'
        },
        {
          name: '12号车沪JZ0739',
          time: '2019-03-23 17:30',
          point: '121.44936,31.18295',
          locate: '近龙华路华容路中心东北 0.168公里, 在上海市内',
          device: '01号车沪ML7903'
        },
        {
          name: '12号车沪JZ0739',
          time: '2019-03-23 17:30',
          point: '121.44936,31.18295',
          locate: '近龙华路华容路中心东北 0.168公里, 在上海市内',
          device: '01号车沪ML7903'
        },
        {
          name: '12号车沪JZ0739',
          time: '2019-03-23 17:30',
          point: '121.44936,31.18295',
          locate: '近龙华路华容路中心东北 0.168公里, 在上海市内',
          device: '01号车沪ML7903'
        },
        {
          name: '12号车沪JZ0739',
          time: '2019-03-23 17:30',
          point: '121.44936,31.18295',
          locate: '近龙华路华容路中心东北 0.168公里, 在上海市内',
          device: '01号车沪ML7903'
        },
        {
          name: '12号车沪JZ0739',
          time: '2019-03-23 17:30',
          point: '121.44936,31.18295',
          locate: '近龙华路华容路中心东北 0.168公里, 在上海市内',
          device: '01号车沪ML7903'
        }
      ]
    }
  },
  methods: {

  },
  mounted() {}
}
</script>

<style lang="less" scoped src="@assets/css/resource/GPS.less"></style>
